import { EMPTY_WELLNESS_DOMAINS } from '@/constants';
import { TPublicScreenerFormForBE } from '@/types/PublicScreener.types';
import { create } from 'zustand';
import { persist, subscribeWithSelector } from 'zustand/middleware';

type TPublicScreenerScoreState = {
  result: TPublicScreenerFormForBE | null;
  organizationSlug: string | null;
};

type TPublicScreenerScoreStore = TPublicScreenerScoreState & {
  setResult: (result: TPublicScreenerFormForBE) => void;
  setOrganizationSlug: (organizationSlug: string) => void;
  reset: () => void;
};

const initialState: TPublicScreenerScoreState = {
  result: { scores: EMPTY_WELLNESS_DOMAINS, totalScore: 0 },
  organizationSlug: null,
};

export const usePublicScreenerStore = create<TPublicScreenerScoreStore>()(
  subscribeWithSelector(
    persist(
      (set) => ({
        ...initialState,
        setResult: (result: TPublicScreenerFormForBE) => {
          set((state) => ({
            ...state,
            result,
          }));
        },
        setOrganizationSlug: (organizationSlug: string) => {
          set((state) => ({
            ...state,
            organizationSlug,
          }));
        },
        reset: () => {
          set((state) => ({
            ...state,
            ...initialState,
          }));
        },
      }),
      { name: 'publicScreenerStore' },
    ),
  ),
);
